import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import {ValidateApi} from 'Users/api/api';
import axiosInstance from 'Shared/utilities/axiosInstance';

const validateApi = new ValidateApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

export default {
  validateTaxIdentifier: (identifier: string) =>
    withCancellation(cancelToken =>
      validateApi.validateValidateIdentifier(identifier, '1', getAxiosConfig(cancelToken, false)).then(handleResponse)
    ),
};
